var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "flex center-xs space-top-1 space-bottom-2" }, [
        _c(
          "div",
          { staticClass: "input-container" },
          [
            _vm._l(_vm.chunkedCheckboxes, function (checkboxRow, index) {
              return _c(
                "div",
                { key: index, staticClass: "row hidden-m justify-center" },
                _vm._l(checkboxRow, function (checkbox, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "vertical-checkbox-space" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inputData,
                            expression: "inputData",
                          },
                        ],
                        staticClass: "hidden",
                        attrs: { type: "checkbox", id: checkbox.value },
                        domProps: {
                          value: checkbox.value,
                          checked: Array.isArray(_vm.inputData)
                            ? _vm._i(_vm.inputData, checkbox.value) > -1
                            : _vm.inputData,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.inputData,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = checkbox.value,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.inputData = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.inputData = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.inputData = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "checkbox-label",
                          attrs: { for: checkbox.value, tabindex: "0" },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.keycheck.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "checkbox-desktop checkbox-unselected flex center-xs",
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: checkbox.unselectedSrc,
                                  alt: checkbox.unselectedAlt,
                                  width: "70",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox-text" }, [
                                _vm._v(_vm._s(checkbox.value)),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "valid-checkbox valid-checkbox-gray",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "checkbox-desktop checkbox-selected flex center-xs",
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: checkbox.selectedSrc,
                                  alt: checkbox.selectedAlt,
                                  width: "70",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox-text" }, [
                                _vm._v(_vm._s(checkbox.value)),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "valid-checkbox valid-checkbox-blue",
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "valid-checkmark" }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "visible-m" },
              _vm._l(_vm.consolidatedCheckboxes, function (checkbox, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "row vertical-checkbox-space" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputData,
                          expression: "inputData",
                        },
                      ],
                      staticClass: "hidden",
                      attrs: { type: "checkbox", id: checkbox.value + "-m" },
                      domProps: {
                        value: checkbox.value,
                        checked: Array.isArray(_vm.inputData)
                          ? _vm._i(_vm.inputData, checkbox.value) > -1
                          : _vm.inputData,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.inputData,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = checkbox.value,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.inputData = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.inputData = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.inputData = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "checkbox-label",
                        attrs: { for: checkbox.value + "-m" },
                      },
                      [
                        _c("div", { staticClass: "mobile-checkbox" }, [
                          _c("div", { staticClass: "checkbox-text" }, [
                            _vm._v(_vm._s(checkbox.value)),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "valid-checkbox valid-checkbox-gray",
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "valid-checkbox valid-checkbox-blue",
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "valid-checkmark" }),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.diplayErrorMessage
              ? _c("div", { staticClass: "red-text space-top-2" }, [
                  _vm._v(_vm._s(_vm.step.errorMessage)),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("ButtonSection", {
        attrs: {
          inputValid: _vm.inputValid,
          order: _vm.order,
          buttonText: _vm.step.buttonText,
        },
        on: {
          progress: _vm.handleProgress,
          back: function ($event) {
            return _vm.$emit("back")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }